<template>
  <main class="wrapper-content">
    <LmComponentLoading v-show="isPageLoading" />
    <LmForm ef="lmFormRef">
    <div id="lm-user-profile">
       <div>
        <div class="wrapper-title-page">
          <h3>{{$t('my_profile')}}</h3>
        </div>
        <b-row>
          <b-col cols="12" class="col-lg-2">
          <div class="justify-content-center d-flex">
            <div class="text-center wrapper-avatar">
               <div class="position-relative">
                  <b-col class="position-absolute" align-self="center" style="bottom:-6px; z-index:2;">
                    <b-button class="position-relative" id="popover-edit" size="sm" variant="primary">
                      <b-icon icon="camera" class="mr-1"></b-icon>
                    Editar
                    </b-button>
                  </b-col>

                  <b-popover placement="bottom" target="popover-edit" variant="secondary" triggers="click" ref="profilePicPopover">
                        <label
                          class="dropdown-item mt-1"
                          @click="showOnlyInputFileMethod"
                          style="cursor: pointer;"
                        >📁 Subir una imagen</label>
                        <label
                          v-if="browserSupportGetUserMedia && deviceHasCamera"
                          class="dropdown-item mt-1"
                          @click="takePhoto"
                          style="cursor: pointer;"
                        >📷 Tomar una foto</label>
                  </b-popover>
                  <LmProfilePicture :size="'10rem'" :profilePreview="form.profilePicture" :avatarClass="'position-relative'"/>
               </div>

              <div class="text-center wrapper-avatar my-3">
                <h1 class="font-weight-bold text-name">{{ `${this.form.firstname} ${this.form.lastname}` }}</h1>
                <h3 class="font-weight-light text-position" v-if="this.positionAsigned">{{ `${this.form.position.name}` }}</h3>
              </div>

            </div>
          </div>
          </b-col>
          <b-col cols="12" class="col-lg-10">
            <b-card no-body class="border">
              <b-tabs v-model="tabIndex" card>
                <b-tab title="Datos Personales" @click="resetPasswordModal()" active>
                  <LmForm id="profile-data-form">
                    <h4>Datos Personales</h4>
                    <b-row>
                      <b-col cols="12" class="col-lg-6">
                        <LmTreeSelect
                          label="Área"
                          pathToGetOptions="/customer/areas"
                          :clearable="true"
                          v-model="form.area"
                        />
                      </b-col>
                      <b-col cols="12" class="col-lg-6">
                        <LmTreeSelect
                          label="Subárea"
                          pathToGetOptions="/customer/subareas"
                          childrenOf="area"
                          :clearable="true"
                          v-model="form.subarea"
                        />
                      </b-col>
                      <b-col cols="12" class="col-lg-12 mb-4">
                        <div>
                          <label for="tags-basic">Grupos</label>
                          <div v-if="!form.groups.length" class="font-italic">
                            No está asociado a ningún grupo
                          </div>
                        </div>
                        <b-badge
                          v-for="(group, index) in form.groups"
                          :key="index"
                          pill
                          class="p-1 px-2 mr-1"
                          variant="primary"
                          v-b-popover.hover.top="group.name"
                        >{{group.name}}
                        </b-badge>
                      </b-col>

                      <b-col cols="12" class="col-lg-4">
                        <LmTextInput
                          v-model="form.firstname"
                          type="text"
                          label="Nombre"
                          />
                      </b-col>
                      <b-col cols="12" class="col-lg-4">
                        <LmTextInput
                          v-model="form.lastname"
                          type="text"
                          label="Apellido"
                          />
                      </b-col>
                      <b-col cols="12" class="col-lg-4">
                        <LmEmailInput
                          v-model="form.email"
                          type="email"
                          label="Email"
                          />
                      </b-col>
                      <!-- <b-col cols="12" class="col-lg-6">
                        <LmTreeSelect
                          label="Tipo de Firma"
                          class="col-12 px-0"
                          pathToGetOptions="/customer/signaturetype"
                          :multiple="false"
                          v-model="form.signatureType"
                          :clearable="true"
                        />
                      </b-col> -->
                      <b-col cols="12" class="col-lg-6">
                        <LmTreeSelect
                          label="Cargo"
                          class="col-12 px-0"
                          pathToGetOptions="/customer/position"
                          :multiple="false"
                          v-model="form.position"
                          :clearable="true"
                        />
                      </b-col>
                      <!--
                      Campo de revisor
                      -->
                      <b-col cols="12" class="col-lg-4">
                        <LmTreeSelect
                          label="Revisor"
                          class="col-12 px-0"
                          pathToGetOptions="/users/allexceptme"
                          :multiple="false"
                          v-model="form.reviewer"
                          :clearable="true"
                        />
                      </b-col>
                    </b-row>
                  </LmForm>
                </b-tab>

                <b-tab title="Datos de Contacto" @click="resetPasswordModal()">
                  <LmForm id="profile-contact-form">
                  <b-row>
                      <b-col class="col-12 col-lg-6">
                        <h4>Teléfonos</h4>

                        <div class="mt-2">
                          <label><b-icon-phone class="mr-2"></b-icon-phone>Personal</label>
                          <b-input-group append="" size="sm">
                            <b-form-input v-model="form.phones[0].number" placeholder="Número de Teléfono"></b-form-input>
                          </b-input-group>
                        </div>

                        <div class="mt-2">
                          <label><b-icon-phone class="mr-2"></b-icon-phone>Laboral</label>
                          <b-input-group append="" size="sm">
                            <b-form-input v-model="form.phones[1].number" placeholder="Número de Teléfono"></b-form-input>
                          </b-input-group>
                        </div>

                        <div class="mt-2">
                          <label><b-icon-telephone class="mr-2"></b-icon-telephone>Casa</label>
                          <b-input-group append="" size="sm">
                            <b-form-input v-model="form.phones[2].number" placeholder="Número de Teléfono"></b-form-input>
                          </b-input-group>
                        </div>
                      </b-col>
                      <b-col class="col-12 col-lg-6 mt-3 mt-lg-0">
                        <h4>Redes Sociales</h4>

                        <div class="mt-2">
                          <label><b-icon-facebook  class="mr-2"></b-icon-facebook>Facebook</label>
                          <b-input-group append="" size="sm">
                            <b-form-input v-model="form.socialMedia[0].link" placeholder="Link"></b-form-input>
                          </b-input-group>
                        </div>

                        <div class="mt-2">
                          <label><b-icon-twitter  class="mr-2"></b-icon-twitter>Twitter</label>
                          <b-input-group append="" size="sm">
                            <b-form-input v-model="form.socialMedia[1].link" placeholder="Link"></b-form-input>
                          </b-input-group>
                        </div>

                        <div class="mt-2">
                          <label><b-icon-linkedin  class="mr-2"></b-icon-linkedin>LinkedIn</label>
                          <b-input-group append="" size="sm">
                            <b-form-input v-model="form.socialMedia[2].link" placeholder="Link"></b-form-input>
                          </b-input-group>
                        </div>

                        <div class="mt-2">
                          <label><b-icon-instagram class="mr-2"></b-icon-instagram>Instagram</label>
                          <b-input-group append="" size="sm">
                            <b-form-input v-model="form.socialMedia[3].link" placeholder="Link"></b-form-input>
                          </b-input-group>
                        </div>
                      </b-col>
                    </b-row>
                  </LmForm>

                </b-tab>

                <b-tab title="Licencias" v-if="showLicensesTab" @click="resetPasswordModal()">
                  <LmLicenses ref="LmLicenses" />
                </b-tab>

                <b-tab title="Mi Firma" v-if="showMySignatureTab" @click="resetPasswordModal()">
                  <b-row>
                    <b-col cols="12">
                      <div class="overlay-image">
                        <div v-if="signature">
                          <label>Firma</label>
                          <div class="img-wrap d-flex justify-content-center align-items-center p-2" style="width: 250px; height: auto;">
                            <b-img class="img-preview" center thumbnail :src="signature" style="width: 250px; height: auto;"></b-img>
                            <div class="img-description-layer">
                              <p class="img-description" @click="handleWriteSignature">Editar Firma</p>
                              <font-awesome-icon class="ml-4 clickable img-description" icon="trash" @click="onRemoveSignature()" style="width:16px; height:16px;" />
                            </div>
                          </div>
                        </div>
                        <div v-else @click="handleWriteSignature">
                          <div
                            class="empty-logo d-flex justify-content-center align-items-center mt-0 clickable"
                            style="max-width: 250px"
                          >
                            <p class="mb-0">Crear Firma</p>
                          </div>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </b-tab>
                <b-tab title="Contraseña" v-if="passwordChangeEnabled">
                  <LmPassword
                    class="col-12 col-lg-6"
                    @enter="saveNewPassword"
                    v-model="passwordForm.password"
                    :v="$v.passwordForm.password"
                    :serverErrorMessage="serverErrorMessage"
                    label="Contraseña actual"
                  />
                  <LmPassword
                    class="col-12 col-lg-6"
                    @enter="saveNewPassword"
                    v-model="passwordForm.newPassword"
                    :v="$v.passwordForm.newPassword"
                    :serverErrorMessage="serverErrorMessage"
                    label="Nueva contraseña"
                    />
                  <LmPassword
                    class="col-12 col-lg-6"
                    @enter="saveNewPassword"
                    v-model="passwordForm.newPasswordAgain"
                    :v="$v.passwordForm.newPasswordAgain"
                    :serverErrorMessage="serverErrorMessage"
                    :label="$t('password_again')"
                  />
                </b-tab>
                <b-tab title="Contraseña" v-else>
                  <div v-html="passwordChangeDisabledMessage"></div>
                </b-tab>
              </b-tabs>
            </b-card>
          </b-col>
        </b-row>
      </div>
     </div>
    <b-modal id="loadAvatar" no-close-on-backdrop :title="loadAvatarModalTitle" size="xl">
      <div class="col-12 justify-content-center d-flex" v-if="!imageToCrop && !mustShowOnlyInputFileMethod">
        <LmCapturePhoto
          @imageChanged="form.profilePicture = $event"
          @capture="loadImageToCrop"
          ref="lmCapturePhoto"
        />
      </div>
      <div v-show="mustShowOnlyInputFileMethod || imageToCrop" id="image-for-avatar-wrapper" class="row">
        <div class="col-12">
          <LmProfileCropper
            ref="lmCropperAvatar"
            hideSaveButton
            hideCropButton
            hideCropImg
            imgToCropWidthAsContainer
            :aspectRatio="1/1"
            :minCropBoxWidth="300"
            :minCropBoxHeight="300"
            :viewMode="1"
            labelFile="Imagen Avatar"
            @imageCropperChanged="form.profilePicture = $event; closeLoadAvatar();"
            @imageLoadedToBeCrop="isImageLoadedToBeCrop = true"
            @reset="isImageLoadedToBeCrop = false"
            :initialImageSrc="form.profilePicture"
            :imgSrc="imageToCrop"
            />
        </div>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100">
          <LmButton
            :disabled="!isImageLoadedToBeCrop"
            id="btn-crop-save-avatar"
            type="button"
            lmButtonRootWrapperClass="d-inline-block mr-1 mt-3"
            buttonClass="btn-primary"
            value="Guardar"
            class="float-right"
            @click.native="cropAvatar"
          />
          <LmButton
            id="btn-crop-cancel-avatar"
            type="button"
            lmButtonRootWrapperClass="d-inline-block mr-1 mt-3"
            buttonClass="btn-secondary"
            :value="$t('Cancel')"
            class="float-right"
            @click.native="closeLoadAvatar"
          />
        </div>
      </template>
    </b-modal>
    <LmSignaturePad ref="lmSignaturePad"/>
    <WacomSignaturePad ref="WacomSignaturePad"/>
  </LmForm>

  <div class="buttons">
    <!-- Tab 1 -->
      <LmButton
        id="btn-cancelar-datospersonales"
        type="button"
        buttonClass="btn-secondary"
        :value="$t('Cancel')"
        @click="cancelBtn()"
        :is-processing="isProcessing"
      />
      <LmButton
        id="btn-guardar-datospersonales"
        type="submit"
        buttonClass="btn-primary"
        :value="$t('Save')"
        @click="onSubmit()"
        :is-processing="isProcessing || isFormProcessing"
        v-if="tabIndex === 0"
      />
      <LmButton
        v-if="!emailWasConfirmed && tabIndex === 0"
        id="btn-guardar-datospersonales"
        type="submit"
        buttonClass="btn-success"
        :value="$t('confirm_email')"
        @click="triggerEmailConfirmation()"
        :is-processing="isProcessing || isFormProcessing"
      />
    <!-- Tab 2 -->
      <LmButton
        id="btn-guardar-contacto"
        type="submit"
        buttonClass="btn-primary"
        :isProcessing="isFormProcessing"
        :value="$t('Save')"
        @click="onSubmit()"
        v-if="tabIndex === 1"
        />
    <!-- Tab 3 -->
      <LmButton
        id="licenseform-button"
        buttonClass="btn-primary"
        :disabled="!enableLicenseButton"
        @click="$refs.LmLicenses.saveNewLicense"
        value="Cargar Licencia"
        v-if="tabIndex === 2"
        />
      <!-- Tab 4 -->
      <LmButton
        buttonClass="btn-primary"
        @click="saveNewPassword"
        value="Modificar Contraseña"
        :disabled="enablePasswordButton"
        v-if="tabIndex === 4"
      />
  </div>
</main>
</template>

<script>
import commonsApi from '@/api/commons'
import { mapState, mapMutations, mapActions } from 'vuex'
import LmCapturePhoto from '@/components/LmCapturePhoto.vue'
import LmProfileCropper from '@/components/LmProfileCropper.vue'
import LmProfilePicture from '@/components/LmProfilePicture.vue'
import LmLicenses from '@/components/LmLicenses.vue'
import LmButton from '@/components/form/elements/LmButton'
import LmForm from '@/components/form/LmForm.vue'
import LmPassword from '@/components/form/elements/LmPassword.vue'
import lmToasts from '@/mixins/lmToasts.js'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmEmailInput from '@/components/form/elements/LmEmailInput'
import LmRepeatFields from '@/components/form/elements/LmRepeatFields'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import draggable from 'vuedraggable'
import { required, minLength, sameAs } from 'vuelidate/lib/validators'
import LmSignaturePad from '@/components/LmSignaturePad'
import WacomSignaturePad from '@/components/WacomSignaturePad'

export default {
  provide () {
    return {
      context: this.form
    }
  },
  mixins: [lmToasts],
  data () {
    return {
      isProcessing: false,
      tabIndex: 0,
      profileCreated: true,
      passwordChangeEnabled: process.env?.VUE_APP_LUMBRE_PASSWORD_CHANGE_ENABLED !== 'no',
      passwordChangeDisabledMessage: process.env?.VUE_APP_LUMBRE_PASSWORD_CHANGE_DISABLED_MESSAGE || 'Lo sentimos, el cambio de contraseña no está habilitado, por favor contacte a su administrador.',
      serverErrorMessage: '',
      loadAvatarModalTitle: '',
      browserSupportGetUserMedia: 'getUserMedia' in navigator.mediaDevices,
      deviceHasCamera: true,
      isImageLoadedToBeCrop: false,
      isPageLoading: true,
      isFormProcessing: true,
      filePreviewPath: false,
      imageToCrop: '',
      mustShowOnlyInputFileMethod: false,
      usernameEdit: false,
      showLicensesTab: process.env.VUE_APP_LUMBRE_LICENSES_ENABLED === 'yes',
      showMySignatureTab: process.env?.VUE_APP_ENABLE_INTERNAL_SIGNATURE_VALIDATIONS === 'yes',
      emailWasConfirmed: false,
      form: {
        phones: [
          { number: '', type: { id: 1, name: 'Personal' } },
          { number: '', type: { id: 2, name: 'Laboral' } },
          { number: '', type: { id: 3, name: 'Casa' } } ],
        socialMedia: [
          { link: '', type: { id: 1, name: 'Facebook' } },
          { link: '', type: { id: 2, name: 'Twitter' } },
          { link: '', type: { id: 3, name: 'LinkedIn' } },
          { link: '', type: { id: 4, name: 'Instagram' } } ],
        area: null,
        subarea: null,
        groups: []
      },
      passwordForm: {
        password: '',
        newPassword: '',
        newPasswordAgain: ''
      },
      signature: null,
      userId: null
    }
  },
  validations: {
    form: {
      firstname: {
        required
      },
      lastname: {
        required
      },
      email: {
        required
      }
    },
    passwordForm: {
      password: {
        required
      },
      newPassword: {
        required,
        minLength: minLength(4)
      },
      newPasswordAgain: {
        sameAsNewPassword: sameAs('newPassword')
      }
    }
  },
  components: {
    draggable,
    LmForm,
    LmCapturePhoto,
    LmButton,
    LmProfileCropper,
    LmProfilePicture,
    LmRepeatFields,
    LmTextInput,
    LmEmailInput,
    LmTreeSelect,
    LmPassword,
    LmLicenses,
    LmSignaturePad,
    WacomSignaturePad
  },
  computed: {
    ...mapState('session', ['userInitials', 'profilePicture', 'username', 'role', 'roles']),
    enableLicenseButton () {
      if (this.$refs.LmLicenses.licenseForm.start && this.$refs.LmLicenses.licenseForm.finish) {
        return true
      } else {
        return false
      }
    },
    enablePasswordButton () {
      if (this.passwordForm.password === '' || this.passwordForm.newPassword.length < 4 || this.passwordForm.newPasswordAgain.length < 4) {
        return true
      } else if (this.passwordForm.newPassword !== this.passwordForm.newPasswordAgain) {
        return true
      } else {
        return false
      }
    },
    positionAsigned () {
      if (this.form.position) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    ...mapMutations('session', ['mutateProfilePicture', 'mutateName']),
    ...mapActions('session', ['getUserInfo']),
    async handleWriteSignature () {
      try {
        this.isProcessing = true
        let base64File
        base64File = await this.$refs.lmSignaturePad.open()

        // const data = await this.$refs.WacomSignaturePad.open()
        // base64File = data.img
        if (base64File) {
          const { data: filePath } = await commonsApi.axiosPutWrapper('/users/upload-signature/' + this.userId, {
            signature: base64File
          })
          this.$store.commit('session/mutateSignature', filePath)

          const { data: signature } = await commonsApi.axiosGetWrapper('/users/get-signature/' + this.userId)
          this.signature = signature
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },
    async onRemoveSignature () {
      this.signature = null
      await commonsApi.axiosPutWrapper('/users/upload-signature/' + this.userId, {
        signature: 'unset'
      })
      this.$store.commit('session/mutateSignature', this.signature)
    },
    loadImageToCrop (dataUrl) {
      this.$refs.lmCropperAvatar.replace(dataUrl)
      this.imageToCrop = dataUrl
    },
    showOnlyInputFileMethod () {
      this.loadAvatarModalTitle = 'Agregar una imagen para el Avatar'
      this.$refs.profilePicPopover.$emit('close')
      this.$bvModal.show('loadAvatar')
      this.mustShowOnlyInputFileMethod = true
    },
    crop () {
      this.$refs.LmProfileCropper.crop()
      this.$refs.LmProfileCropper.submit()
    },
    cropAvatar () {
      this.$refs.lmCropperAvatar.crop()
      this.$refs.lmCropperAvatar.submit()
    },
    closeLoadAvatar () {
      this.$forceUpdate()
      this.$bvModal.hide('loadAvatar')
      this.imageToCrop = ''
      this.$refs.lmCropperAvatar.reset()
    },
    async takePhoto () {
      this.loadAvatarModalTitle = 'Tomar una foto para el Avatar'
      this.$refs.profilePicPopover.$emit('close')
      this.$bvModal.show('loadAvatar')
      this.mustShowOnlyInputFileMethod = false
      this.$nextTick(async () => {
        this.deviceHasCamera = await this.$refs.lmCapturePhoto.getUserMedia()
        if (!this.deviceHasCamera) this.$bvModal.hide('loadAvatar')
      })
    },
    async onSubmit () {
      try {
        this.isFormProcessing = true
        await this.validateForm(this.form)

        // Asigno las iniciales del usuario en caso que haya sido modificado el nombre
        this.form.userInitials = this.form.firstname.charAt(0) + this.form.lastname.charAt(0)

        let res
        if (!this.profileCreated) {
          // Nuevo
          res = await commonsApi.axiosPostWrapper(`/profile/new/${this.form.userId}`, this.form)
          this.lmToastSuccessMessage(`Se creó ${res?.data?.name || ' el perfil'} correctamente.`, 'Se guardó exitosamente')
        } else {
          // Editar
          res = await commonsApi.axiosPutWrapper(`/profile/edit/${this.form.userId}`, this.form)
          this.lmToastSuccessMessage(`Se editó ${res?.data?.name || ' el perfil'} correctamente.`, 'Se guardó exitosamente')
        }
        await this.getUserInfo()

        setTimeout(() => {
          this.mutateProfilePicture(this.form.profilePicture)
          this.mutateName(this.form)
          this.$router.push('/inbox')
        }, 650)
      } finally {
        this.isFormProcessing = false
      }
    },
    validateForm (validation) {
      // Valido el email con https://emailregex.com/
      const emailregex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!emailregex.test(validation.email)) {
        this.lmToastDangerMessage(this.$t('El email ingresado no es válido'), 'Error')
        throw new Error('validation error')
      }

      // Verifico que los teléfonos y las redes sociales tengan contenido en caso que exista el campo
      if (validation.phones) {
        validation.phones.map(phone => {
          if (phone.number !== null && phone.number.length !== 0 && phone.number.length < 5) {
            this.lmToastDangerMessage(this.$t(`El teléfono ingresado en ${phone.type.name || ''} es inválido`), 'Error')
            throw new Error('validation error')
          }
        })
      }

      if (validation.socialMedia) {
        validation.socialMedia.map(socialMedia => {
          const socialMediaLinkRegex = /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/

          if (socialMedia.link !== '' && !socialMediaLinkRegex.test(socialMedia.link)) {
            this.lmToastDangerMessage(this.$t(`El link ingresado en ${socialMedia.type.name} es inválido`), 'Error')
            throw new Error('validation error')
          }
        })
      }
    },
    addSocialMedia () {
      if (!this.form.socialMedia) {
        this.form.socialMedia = [{ link: '', type: { id: 1, name: 'Facebook' } }]
      } else {
        this.form.socialMedia.push({ link: '', type: { id: 1, name: 'Facebook' } })
      }
      this.$forceUpdate()
    },
    removeSocialMedia (index) {
      this.form.socialMedia.splice(index, 1)
      this.$root.$emit('bv::toggle::collapse', `socialMedia-${index}`)
      this.$forceUpdate()
    },
    addPhone () {
      if (!this.form.phones) {
        this.form.phones = [{ number: '', type: { id: 1, name: 'Personal' } }]
      } else {
        this.form.phones.push({ number: '', type: { id: 1, name: 'Personal' } })
      }
      this.$forceUpdate()
    },
    removePhone (index) {
      this.form.phones.splice(index, 1)
      this.$root.$emit('bv::toggle::collapse', `phone-${index}`)
      this.$forceUpdate()
    },
    cancelBtn () {
      this.$router.push('/inbox')
    },
    async saveNewPassword () {
      this.$v.passwordForm.$touch()
      if (!this.$v.passwordForm.$invalid) {
        try {
          await commonsApi.axiosPutWrapper('/users/password/change/', this.passwordForm)
          this.lmToastSuccessMessage(`Se modificó la contraseña correctamente.`, 'Contraseña modificada')
        } catch (error) {
          console.log(error)
        }
      }
      this.resetPasswordModal()
    },
    resetPasswordModal () {
      this.passwordForm.password = ''
      this.passwordForm.newPassword = ''
      this.passwordForm.newPasswordAgain = ''
      this.$v.passwordForm.$reset()
    },
    async triggerEmailConfirmation () {
      try {
        this.isFormProcessing = true

        this.lmModalInformationMessage({
          resultSubtitle: '',
          modalClosable: false,
          buttons: [
            {
              btnText: this.$t('i_will_do_it_later'),
              btnType: 'danger',
              btnGhost: true,
              btnLink: 'close'
            },
            {
              btnText: this.$t('continue'),
              btnCallback: async () => {
                await commonsApi.axiosPostWrapper('/users/request-email-validation')
                this.lmToastSuccessMessage(`${this.$t('email_confirmation_request_done_successfully')}`)
              }
            }
          ],
          message: this.$t('previous_email_confirmation_message')
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.isFormProcessing = false
      }
    }
  },
  async mounted () {
    try {
      // Obtengo la información del usuario
      const getUser = await commonsApi.axiosGetWrapper(`/profile/userinfo`)
      const user = getUser.data

      this.userId = user.userId

      if ('emailWasConfirmed' in user) {
        this.emailWasConfirmed = user.emailWasConfirmed
        delete user.emailWasConfirmed
      }

      // Con la información del usuario obtengo la info del perfil si fue creado
      const getProfile = await commonsApi.axiosGetWrapper(`/profile/user/${user.userId}`)
      const profile = getProfile.data

      const { data: signature } = await commonsApi.axiosGetWrapper('/users/get-signature/' + user.userId)
      this.signature = signature

      let groupData = {
        groups: []
      }
      try {
        // Con la información del usuario obtengo la info del perfil si fue creado
        const getGroups = await commonsApi.axiosGetWrapper(`/usersgroups/my_groups`)
        groupData = getGroups.data
      } catch (error) {
        console.log(error)
      }

      // Verifico si el usuario ya tiene perfil creado para luego hacer post/put según corresponda
      if (!getProfile.data) this.profileCreated = false

      // Object.assign para no perder reactividad y watchers
      Object.assign(this.form, user, profile, groupData)
    } finally {
      this.isFormProcessing = false
    }
    this.isPageLoading = false
  },
  async beforeDestroy () {
    if (this.deviceHasCamera) {
      await navigator.mediaDevices.getUserMedia({
        video: false
      })
    }
  }
}
</script>

<style lang="sass" scoped>
  #lm-user-profile
    .wrapper-avatar
      #avatar-user
        .avatar-user-img
          max-height: 100%
        .camera-icon
          position: absolute
          bottom: 20px
      .text-name
        font-size: 22px
      .text-position
        font-size: 20px
  .crop-img
    max-width: 300px
    max-height: 100px
</style>
